import { render, staticRenderFns } from "./RiskPermitWork.vue?vue&type=template&id=09f4b11b&scoped=true&"
import script from "./RiskPermitWork.vue?vue&type=script&lang=js&"
export * from "./RiskPermitWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f4b11b",
  null
  
)

export default component.exports